import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { CommissioningRequestDtoModel } from '@bo-client/activation-management/shared/models/commissioningRequestDto';
import { UserDto } from '@bo-client/shared/models/userDto';
import { GisDataModel } from '@bo-client/shared/models/gisData';
import { CompanyLocationDto } from '@bo-client/shared/models/companyLocations';
import {
  AreaTypeEnum,
  CommissioningStatusEnum
} from '@bo-client/activation-management/shared/models/commissioningModel';

@Injectable({
  providedIn: 'root'
})
export class LoadDataFormsService {
  loadPowerDataToSave(
    currentComm: CommissioningRequestDtoModel,
    currentForm: FormGroup
  ): CommissioningRequestDtoModel {
    currentComm.actions = (currentForm.get('actions') as FormArray).getRawValue();
    currentComm.actions.map((action) => ({
      ...action,
      devices: action.devices.map((device) => ({
        ...device,
        gridRegistration: device.gridRegistration?.id ? { id: device.gridRegistration.id } : undefined
      }))
    }));
    console.log('current form value', currentComm.actions);
    // currentComm.newDevice = currentForm.get('transactionType').get('newDevice').value;
    // currentComm.eHeating = currentForm.get('transactionType').get('eHeating').value;
    // currentComm.powerIncrease = currentForm.get('transactionType').get('powerIncrease').value;
    // currentComm.devicesSplitting = currentForm.get('transactionType').get('devicesSplitting').value;
    // currentComm.deviceMerging = currentForm.get('transactionType').get('deviceMerging').value;
    // currentComm.apportionment = currentForm.get('transactionType').get('apportionment').value;
    // currentComm.connectionUsageSetting = currentForm
    //   .get('transactionType')
    //   .get('connectionUsageSetting').value;
    // currentComm.changeMeasuringDevice = currentForm.get('transactionType').get('changeMeasuringDevice').value;
    // currentComm.comment = currentForm.get('transactionType').get('comment').value;

    currentComm = {
      ...currentComm,
      ...currentForm.get('transactionType').value
    };
    return currentComm;
  }

  loadDistrictHeatDataToSave(
    currentComm: CommissioningRequestDtoModel,
    currentForm: FormGroup
  ): CommissioningRequestDtoModel {
    currentComm.actions = (currentForm.get('actions') as FormArray).value;
    currentComm.newDevice = currentForm.get('transactionType').get('newDevice').value;
    currentComm.eHeating = currentForm.get('transactionType').get('eHeating').value;
    currentComm.powerIncrease = currentForm.get('transactionType').get('powerIncrease').value;
    currentComm.devicesSplitting = currentForm.get('transactionType').get('devicesSplitting').value;
    currentComm.deviceMerging = currentForm.get('transactionType').get('deviceMerging').value;
    currentComm.apportionment = currentForm.get('transactionType').get('apportionment').value;
    currentComm.connectionUsageSetting = currentForm
      .get('transactionType')
      .get('connectionUsageSetting').value;
    currentComm.changeMeasuringDevice = currentForm.get('transactionType').get('changeMeasuringDevice').value;
    currentComm.comment = currentForm.get('transactionType').get('comment').value;
    currentComm.uploads = (currentForm.get('uploads') as FormArray).value;
    return currentComm;
  }

  loadGasDataToSave(
    currentComm: CommissioningRequestDtoModel,
    currentForm: FormGroup,
    deactivateChimneySign: boolean
  ): CommissioningRequestDtoModel {
    currentComm.actions = (currentForm.get('actions') as FormArray).value;
    currentComm.comment = currentForm.get('gasMoreInformation').get('freeDescription').value;
    if (deactivateChimneySign) {
      currentComm.chimneySweepMail = currentForm.get('chimneySweepMail').value;
    }
    currentComm.installationHasChanged = currentForm.get('installationHasChanged').value;
    return currentComm;
  }

  loadWaterDataToSave(
    currentComm: CommissioningRequestDtoModel,
    currentForm: FormGroup
  ): CommissioningRequestDtoModel {
    currentComm.actions = (currentForm.get('actions') as FormArray).value;
    currentComm.comment = currentForm.get('waterMoreInformation').get('freeDescription').value;
    return currentComm;
  }

  loadCommonDataToSave(
    userDto: UserDto,
    selectedGisData: GisDataModel,
    selectedCompanyLocation: CompanyLocationDto,
    currentComm: CommissioningRequestDtoModel,
    currentForm: FormGroup
  ): CommissioningRequestDtoModel {
    currentComm.meterOperatorBDEWCode = currentForm.get('meterOperatorBDEWCode')?.value;
    currentComm.technician = userDto;
    currentComm.companyLocation = selectedCompanyLocation;
    // additional Object
    // TODO: this is al ittle bit smelly.. refactor this to reduce redundancy and imrpove maintanability of model changes
    if (selectedGisData) {
      if (!currentComm.connectionObject) {
        currentComm.connectionObject = {};
      }
      currentComm.connectionObject.street = selectedGisData.street;
      currentComm.connectionObject.streetNo = selectedGisData.houseNo;
      currentComm.connectionObject.streetNoAddition = selectedGisData.houseNoAddition;
      currentComm.connectionObject.zipCode = selectedGisData.zipCode;
      currentComm.connectionObject.city = selectedGisData.city;
      currentComm.connectionObject.developmentAreaName = selectedGisData.developmentAreaName;
      currentComm.connectionObject.corridorNumber = selectedGisData.corridorNumber;
      currentComm.connectionObject.sapLocationId = selectedGisData.sapDistrictNumber;
      currentComm.connectionObject.district = selectedGisData.district;
      currentComm.uniqueCoId = selectedGisData.uniqueCoId;
    }
    if (currentForm.get('shortDescription')) {
      currentComm.shortDescription = currentForm.get('shortDescription').value;
    }
    if (currentForm.get('installerFeedbackComment')) {
      currentComm.installerFeedbackComment = currentForm.get('installerFeedbackComment').value;
    }
    if (currentForm.get('gridConnectionPointId')) {
      currentComm.gridConnectionPointId = currentForm.get('gridConnectionPointId').value;
    }

    const listFiliation: any = (currentForm.get('filiationData') as FormArray).value;

    // additional Object info
    if (currentForm.get('additionalInfoConnectionObject')) {
      if (currentForm.get('additionalInfoConnectionObject').get('isNewBuilding')) {
        currentComm.connectionObjectAdditionalInfo.isNewBuilding = currentForm
          .get('additionalInfoConnectionObject')
          .get('isNewBuilding').value;
      }
      if (currentForm.get('additionalInfoConnectionObject').get('buildingType')) {
        currentComm.connectionObjectAdditionalInfo.buildingType = currentForm
          .get('additionalInfoConnectionObject')
          .get('buildingType').value;
      }
      if (currentForm.get('additionalInfoConnectionObject').get('numberOfFlats')) {
        currentComm.connectionObjectAdditionalInfo.numberOfFlats = currentForm
          .get('additionalInfoConnectionObject')
          .get('numberOfFlats').value;
      }
      if (currentForm.get('additionalInfoConnectionObject').get('numberOfUsers')) {
        currentComm.connectionObjectAdditionalInfo.numberOfUsers = currentForm
          .get('additionalInfoConnectionObject')
          .get('numberOfUsers').value;
      }
      if (currentForm.get('additionalInfoConnectionObject').get('numberOfOtherUsers')) {
        currentComm.connectionObjectAdditionalInfo.numberOfOtherUsers = currentForm
          .get('additionalInfoConnectionObject')
          .get('numberOfOtherUsers').value;
      }
      if (currentForm.get('additionalInfoConnectionObject').get('objectUsage')) {
        currentComm.connectionObjectAdditionalInfo.objectUsage = currentForm
          .get('additionalInfoConnectionObject')
          .get('objectUsage').value;
      }
    }
    if (currentForm.get('uploads')) {
      currentComm.uploads = (currentForm.get('uploads') as FormArray).value.filter((ele) => ele.url);
    }
    currentComm.customer = listFiliation[0];
    if (listFiliation.length > 1) {
      currentComm.hasDifferentInvoiceContact = true;
      currentComm.invoiceContact = listFiliation[1];
    } else {
      currentComm.hasDifferentInvoiceContact = false;
      currentComm.invoiceContact = null;
    }
    return currentComm;
  }

  loadSupplyAppointmentDate(currentComm: CommissioningRequestDtoModel, currentForm: FormGroup): FormGroup {
    const savedDate = new Date(currentComm.supplyAppointment);
    currentForm.get('supplyAppointment').get('date').patchValue(currentComm.supplyAppointment);
    const stringMinutes =
      savedDate.getUTCMinutes().toString().length == 1
        ? '0' + savedDate.getUTCMinutes().toString()
        : savedDate.getUTCMinutes().toString();
    currentForm
      .get('supplyAppointment')
      .get('time')
      .patchValue(savedDate.getHours() + ':' + stringMinutes);
    return currentForm;
  }

  setAcceptedConditionsAfterLoadCommissioning(
    commissioningDto: CommissioningRequestDtoModel,
    currentForm: FormGroup,
    deactivateChimneySign = true,
    isGas = false
  ): FormGroup {
    if (
      commissioningDto.state != CommissioningStatusEnum.Incomplete &&
      commissioningDto.state != CommissioningStatusEnum.DefectReported &&
      commissioningDto.state != CommissioningStatusEnum.ReadyToApprove
    ) {
      currentForm.get('acceptConditions').get('installationCorrectlyExecuted').patchValue(true);
      currentForm.get('acceptConditions').get('installationCorrectlyExecuted').disable();
      currentForm.get('acceptConditions').get('ownerConsent').patchValue(true);
      currentForm.get('acceptConditions').get('ownerConsent').disable();
      if (currentForm.get('acceptConditions').get('chimneySweepConfirmation')) {
        currentForm.get('acceptConditions').get('chimneySweepConfirmation').patchValue(true);
        currentForm.get('acceptConditions').get('chimneySweepConfirmation').disable();
      }
    }
    return currentForm;
  }

  disabledConditionsAfterSaveCommissioning(
    currentForm: FormGroup,
    deactivateChimneySign = true,
    isGas = false
  ): FormGroup {
    currentForm.get('acceptConditions').get('installationCorrectlyExecuted').disable();
    currentForm.get('acceptConditions').get('ownerConsent').disable();
    if (isGas && deactivateChimneySign) {
      currentForm.get('acceptConditions').get('chimneySweepConfirmation').disable();
    }
    return currentForm;
  }

  loadIdsActionsDevicesAfterSaveCommissioning(
    currentForm: FormGroup,
    savedCommissioning: CommissioningRequestDtoModel
  ): FormGroup {
    currentForm.get('actions').patchValue(savedCommissioning.actions);
    return currentForm;
  }

  setFirstAvailableDate(supplyAppointmentDays: number): Date {
    const toMilliSeconds = 24 * 60 * 60 * 1000;
    let availableDate: Date = new Date(new Date().getTime() + supplyAppointmentDays * toMilliSeconds);
    switch (availableDate.getDay()) {
      case 6: // Saturday
        availableDate = new Date(availableDate.getTime() + 2 * toMilliSeconds);
        break;
      case 0: // Sunday
        availableDate = new Date(availableDate.getTime() + 1 * toMilliSeconds);
        break;
    }
    return availableDate;
  }

  loadDataSaveByArea(
    areaType: AreaTypeEnum,
    commissioningOrderDto: CommissioningRequestDtoModel,
    form: FormGroup
  ) {
    switch (areaType) {
      case AreaTypeEnum.POWER:
        return this.loadPowerDataToSave(commissioningOrderDto, form);
      case AreaTypeEnum.GAS:
        return this.loadGasDataToSave(commissioningOrderDto, form, true);
      case AreaTypeEnum.WATER:
        return this.loadWaterDataToSave(commissioningOrderDto, form);
      case AreaTypeEnum.DISTRICTHEAT:
        return this.loadDistrictHeatDataToSave(commissioningOrderDto, form);
    }
  }

  loadAppointmentDateToSave(commissioningOrderDto: CommissioningRequestDtoModel, formGroup: FormGroup) {
    const supplyDateValue = formGroup.get('supplyAppointment').get('date').value;
    if (supplyDateValue) {
      commissioningOrderDto.supplyAppointment = new Date(supplyDateValue);
    }
    commissioningOrderDto.supplyAppointmentWishDate = formGroup
      .get('supplyAppointment')
      .get('supplyAppointmentWishDate').value
      ? new Date(formGroup.get('supplyAppointment').get('supplyAppointmentWishDate').value)
      : null;
    commissioningOrderDto.supplyAppointmentWishPartday = formGroup
      .get('supplyAppointment')
      .get('supplyAppointmentWishPartday').value;
    return commissioningOrderDto;
  }
}
